import {configureStore} from '@reduxjs/toolkit';
import appReducer from "./app-slice";
import authReducer from "./auth-slice";
import dataReducer from "./data-slice";
import alertsReducer from "./alerts-slice";
import tourReducer from "./tour-slice";

const store = configureStore({
    reducer: {
        app: appReducer,
        auth: authReducer,
        data: dataReducer,
        alerts: alertsReducer,
        tour: tourReducer
    }
})

export default store;
